// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.4.36/static/js/" + chunkId + "." + "8670b72f" + ".chunk.js";
};